(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lockedScrollY = 0;
  const AERA = (window.AERA = window.AERA || {});

  AERA.prefersReducedMotion = () => motionQuery.matches;
  AERA.ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  };
  AERA.scrollLock = {
    lock() {
      if (document.body.classList.contains('aera-scroll-locked')) return;
      lockedScrollY = window.scrollY;
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.classList.add('aera-scroll-locked');
    },
    unlock() {
      if (!document.body.classList.contains('aera-scroll-locked')) return;
      document.body.classList.remove('aera-scroll-locked');
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
    },
  };

  const initializeHeaders = (scope = document) => {
    scope.querySelectorAll('[data-aera-header]').forEach((header) => {
      if (header.dataset.aeraInitialized === 'true') return;
      header.dataset.aeraInitialized = 'true';

      const desktopScrollQuery = window.matchMedia('(min-width: 990px)');
      let frameRequested = false;
      let scrollTarget;
      const updateHeader = () => {
        const scrollTop = scrollTarget === window ? window.scrollY : scrollTarget?.scrollTop || 0;
        header.dataset.scrolled = scrollTop > 12 ? 'true' : 'false';
        frameRequested = false;
      };
      const requestUpdate = () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateHeader);
      };
      const bindScrollTarget = () => {
        scrollTarget?.removeEventListener('scroll', requestUpdate);
        scrollTarget = desktopScrollQuery.matches
          ? document.querySelector('.page-wrapper') || window
          : window;
        scrollTarget.addEventListener('scroll', requestUpdate, { passive: true });
        updateHeader();
      };

      desktopScrollQuery.addEventListener('change', bindScrollTarget);
      bindScrollTarget();
    });

    scope.querySelectorAll('[data-aera-mobile-menu]').forEach((menu) => {
      if (menu.dataset.aeraInitialized === 'true') return;
      menu.dataset.aeraInitialized = 'true';

      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => {
        if (menu.open) AERA.scrollLock.lock();
        else AERA.scrollLock.unlock();
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.open) return;
        menu.open = false;
        summary?.focus();
      });
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          menu.open = false;
        });
      });
    });
  };

  AERA.ready(() => {
    document.documentElement.classList.add('aera-ready');
    initializeHeaders();
    document.addEventListener('aera:drawer:open', () => AERA.scrollLock.lock());
    document.addEventListener('aera:drawer:close', () => AERA.scrollLock.unlock());
    document.addEventListener('shopify:section:load', (event) => initializeHeaders(event.target));
  });
})();
